<div class="pdf-page app-aul-009-24" id="aul00924">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b>FORTEGRA SPECIALTY INSURANCE COMPANY</b>
  </p>
  <p class="font-medium">
    <b
      >For information or questions about your insurance, coverage, or policy,
      you should, as a first step, contact the licensed insurance professional
      who assisted you in the purchase of this insurance.</b
    >
  </p>
  <br />
  <div class="font-small">
    <p>
      If your questions or concerns are in relation to claims made under your
      policy, you should contact our
      <b>appointed claims management service provider:</b>
    </p>
    <p class="mb-0"><b>Triton Claims Management LLC</b></p>
    <p class="mb-0"><b>2400 Lakeview Parkway</b></p>
    <p class="mb-0"><b>Suite 475</b></p>
    <p><b>Alpharetta, Georgia 30009</b></p>
    <p>
      In the event you are dissatisfied with any aspect of this insurance or
      wish to make a complaint then you should provide us with full details in
      writing. This should be sent to the address below:
    </p>
    <p class="mb-0"><b>Complaints Department</b></p>
    <p class="mb-0"><b>Fortegra Specialty Insurance Company</b></p>
    <p class="mb-0"><b>10751 Deerwood Park Blvd.</b></p>
    <p class="mb-0"><b>Suite 200</b></p>
    <p class="mb-0"><b>Jacksonville, Florida 32256</b></p>
    <a href="mailto:consumercomplaints@fortegra.com">
      consumercomplaints&#64;fortegra.com
    </a>
        <br />
    <p>
      Be sure to include your name and the policy reference number as well as
      your contact details.
    </p>
    <p>
      If you remain dissatisfied and we are not able to resolve your complaint,
      you may also be able to refer any complaint to your relevant home state
      Department of Insurance or appropriate equivalent agency. Their contact
      details can be provided by the licensed insurance professional who
      assisted you in the purchase of this insurance, or by visiting the NAIC
      website at
      <a
        href="https://content.naic.org/state-insurance-departments"
        target="_blank"
        >https://content.naic.org/state-insurance-departments.</a
      >
    </p>
  </div>
</div>
